import { Routes } from '@angular/router';
import { NotConstructionGuard } from './guards/not-construction.guard';
import { UnderConstructionGuard } from './guards/under-construction.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full',
  },
  // //* General Pages
  {
    path: 'redirect',
    loadComponent: () => import('./modules/general/pages/redirect/redirect.page').then((m) => m.RedirectPage),
  },
  {
    path: 'under-construction',
    loadComponent: () => import('./modules/general/pages/under-construction/under-construction.page').then( m => m.UnderConstructionPage),
    canActivate: [NotConstructionGuard]
  },
  {
    path: '',
    loadComponent: () => import('./layouts/general/general.component').then((m) => m.GeneralLayout),
    loadChildren: () => import('./routes/app.routes'),
    canActivate: [UnderConstructionGuard]
  },
  // //* Auth routes
  {
    path: '',
    loadComponent: () => import('./layouts/general/general.component').then((m) => m.GeneralLayout),
    loadChildren: () => import('./routes/auth.routes'),
    canActivate: [UnderConstructionGuard]
  },
  {
    path: '**',
    redirectTo : '/',
    pathMatch: 'full',
  },
];
